module.exports = __webpack_public_path__ + "img/project_background.f7340c73.jpeg";